/* Add Product in to cart from product grid */
$(".btnAddFromGrid").click( function(){
  console.log("X");
  var curr_obj = $(this);
  var curr_obj_form = curr_obj.parents("form");

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(curr_obj_form).serialize(),
    dataType: 'json',
    success: function(line_item) { 
      window.location.href = '/cart';
    },
    error: function(XMLHttpRequest, textStatus) {
      window.location.href = '/cart';
    }
  });
});
/* Add Product in to cart from product grid */

/* Fire quora event on prodyct page add to cart click */
$(".btn_addtobag_new").click( function(){
  qp('track', 'Purchase');
  console.log("quora click fire");
});


$('.pnp-media').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots:true
  });

// $(function() {
//   function adjustHeaderPosition() {
//     var $widget = $('.up-widget-timer');
//     var $header = $('.site-i-header');
//     if ($widget.length && $header.length) {
//       if ($(window).width() <= 767) {
//         var widgetHeight = $widget.outerHeight();
//         $header.css('top', widgetHeight + 'px');
//       } else {
//         $header.css('top', '0');
//       }
//     }
//   }
//   $(window).on('resize', adjustHeaderPosition);
//   var checkInterval = setInterval(function() {
//     if ($('.up-widget-timer').length && $('.up-widget-timer').outerHeight() > 0) {
//       adjustHeaderPosition();
//       clearInterval(checkInterval);
//     }
//   }, 350);
// });


$(function() {
  function adjustLayout() {
    var $widget = $('.up-widget-timer');
    var $header = $('.site-i-header');
    var $pageContainer = $('#PageContainer');
    if ($header.length && $pageContainer.length) {
      var widgetHeight = ($widget.length && $(window).width() <= 767) ? $widget.outerHeight() : 0;
      var headerHeight = $header.outerHeight();
      if ($(window).width() <= 767) {
        $header.css('top', widgetHeight + 'px');
        $pageContainer.css('padding-top', (headerHeight + widgetHeight) + 'px');
      } else {
        $header.css('top', '0');
        $pageContainer.css('padding-top', 'unset');
      }
      
    }
  }
  $(window).on('resize', adjustLayout);
  var checkInterval = setInterval(function() {
    if ($('.up-widget-timer').length && $('.up-widget-timer').outerHeight() > 0) {
      adjustLayout();
      clearInterval(checkInterval);
    }
  }, 400);
  setTimeout(adjustLayout, 1000);
});